import React, { useState, useEffect } from "react";
import { ImAppleinc } from "react-icons/im";
import { IoMdClose } from "react-icons/io";
import {
  IoCloseSharp,
  IoLogoGooglePlaystore,
  IoSearchOutline,
} from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import { Link, NavLink, useLocation } from "react-router-dom";
import Profile from "../Profile/profile";
import NavbarTop from "./NavbarTop";
import AOS from "aos";
import "aos/dist/aos.css";
import logo from "../../assets/logo.png";
import CarSearchForm from "./CarSearchForm";
import { useDispatch, useSelector } from "react-redux";
import { clearSearchQuery } from "../../redux/Slice/carSlice";

const Index = () => {
  const loginUserDetail = useSelector((state) => state?.auth?.loginId);
  const getBannerData = useSelector((state) => state?.car?.getBannerData);
  const userInfo = useSelector((state) => state?.auth?.userDetail);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setOpen(!open);
  };

  const searchShow = () => {
    setShow(true);
  };

  const searchHide = () => {
    setShow(false);
  };

  const handleClose = () => {
    dispatch(clearSearchQuery());
    setOpen(false);
  };

  // useEffect(() => {
  //   if (loginUserDetail?.success === true) {
  //     // navigate('/');
  //     // notify(`${loginUserDetail.message}`)
  //   }
  // })

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    if (open) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [open]);
  return (
    <div
      className={location.pathname === "/" ? "home-navbar-div" : "navbar-div"}
    >
      <NavbarTop />
      <nav className="main-nav">
        <div className="d-flex  align-items-center ">
          <Link to="/">
            <img src={logo} width="150px" className="logo_img" />
          </Link>
        </div>
        <div>
          <ul className={open ? "link-list link-list-active" : "link-list"}>
            <div onClick={toggleMenu} className="cross-icon">
              <IoMdClose />
            </div>
            {/* <div id="search-bar" className={show ? "show desktop" : 'desktop'} >
              <div onClick={searchHide} id="srch-close-btn" className={show ? "button show mt-3" : "button"} ><IoCloseSharp /></div>
              <div onClick={searchShow} id="search-button" className="button"><IoSearchOutline /></div>
              <input type="text" id="mob-search" className="search-input" placeholder="Search" name="mob-search" autoCapitalize="off" />
            </div> */}
            <li>
              <NavLink onClick={handleClose} to="/">
                Home
              </NavLink>
            </li>
            <li>
              <NavLink onClick={handleClose} to="/carlist">
                Cars
              </NavLink>
            </li>
            <li>
              <NavLink onClick={handleClose} to="/aboutus">
                About us
              </NavLink>
            </li>
            <li>
              <NavLink onClick={handleClose} to="/contactUs">
                Contact us
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="nav-right d-flex flex-row align-items-center">
          {/* <div>
            <div id="search-bar" className={show ? "show mobile" : "mobile"} >
              <div onClick={searchHide} id="srch-close-btn" className={show ? "button show" : "button"} ><IoCloseSharp /></div>
              <div onClick={searchShow} id="search-button" className="button"><IoSearchOutline /></div>
              <input type="text" id="web-search" className="search-input" placeholder="Search" name="web-search" autoComplete="off" />
            </div>
          </div> */}
          {loginUserDetail ? (
            <Profile />
          ) : (
            <Link to="/login">
              <button
                type="button"
                className="btn px-3 mt-1 img-btn primaryColor"
              >
                Log in
              </button>
            </Link>
          )}
          <div id="mobile">
            <span onClick={toggleMenu}>
              <RxHamburgerMenu className="hamburger-icon" />
            </span>
          </div>
        </div>
      </nav>
      {location.pathname === "/" ? (
        <section className="container-xxl max_container my-auto">
          {/* <div className="image-section"> */}
          <div className="">
            <div data-aos="fade-up" data-aos-duration="3000">
              <h1 className="primaryColor fs56">
                Looking for a <span className="accentColor">vehicle</span>?{" "}
                <br /> You're at the right place.
              </h1>
            </div>
            <div
              data-aos="fade-up"
              data-aos-delay="500"
              data-aos-duration="3000"
              className="mb-5"
            >
              <div className="flex-app social-btns hide-mob">
                <a
                  className="app-btn blu flex vert"
                  target="_blank"
                  href="https://apps.apple.com/us/app"
                >
                  <ImAppleinc className="download-icon" />
                  <p>
                    Available on the <br />{" "}
                    <span className="big-txt">App Store</span>
                  </p>
                </a>
                <a
                  className="app-btn blu flex vert"
                  target="_blank"
                  href="https://play.google.com/store/apps"
                >
                  <IoLogoGooglePlaystore className="download-icon" />
                  <p>
                    Get it on <br />{" "}
                    <span className="big-txt">Google Play</span>
                  </p>
                </a>
              </div>
            </div>
            <div
              data-aos="fade-up"
              data-aos-delay="1000"
              data-aos-duration="3000"
            >
              <CarSearchForm ishome={true} />
            </div>
          </div>
        </section>
      ) : null}
    </div>
  );
};

export default Index;
